module.exports = __webpack_public_path__ + "img/arrowgif_1x.7b04a192.gif";